import React from "react";

const RenderAnswerSelect = (props: any) => {
    const options = props.answerList;

    const onChange = (e: any) => {
        var val = e.target.value;
        props.onChange(val);
    };

    const onSelect = (e: any) => {
        const { id } = e.target;
        props.onChange(id);
    };

    return (
        <React.Fragment>
            <div className="row">
                <div className="col-xs-12 col-no-gutter">
                    <div className="form-row row">
                        <div className="form-label col-xs-12 col-no-gutter">
                            <label htmlFor={`label-question-${props.id}`}>{props.Title}</label>
                        </div>
                        {options.length > 6 ? (
                            <div className="form-input col-xs-12 col-sm-3 col-no-gutter">
                                <select className="inputbox" id={`label-question-${props.id}`} onClick={(e: any) => onChange(e)}>
                                    <option value="">Please select...</option>
                                    {options.map((option: string, index: number) => (
                                        <option key={`option-${option}-${index}`} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        ) : (
                            <div className="col-xs-12 col-no-gutter">
                                <div className="row">
                                    {options.map((option: string, index: number) => (
                                        <div key={`option-${option}-${index}`} className="col-xs-12 col-no-gutter">
                                            <div className="form-row no-margin">
                                                <div className="form-input">
                                                    <label className="form-radio-label">
                                                        <input type="radio" id={`label-question-${props.id}-${index}`} name={props.id} onClick={(e: any) => onSelect(e)} />
                                                        <span className="form-radio-label-text">{option + ' '.repeat(props.id.length)}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default RenderAnswerSelect;
